export const setStandLegPathStroke = (self, { stroke }) => {
  const stand_leg_path_el = self._getStandLegPathElThrowable();
  stand_leg_path_el.setAttributeNS(null, "stroke", stroke);
};
